import { Component, OnInit } from '@angular/core';
import { DataManipService } from 'src/app/services/data-sharing.service';
import { CurrentratesService } from './currentrates.service';

@Component({
    selector: 'app-market-ticker',
    //standalone: true,
    //imports: [],
    templateUrl: './market-ticker.component.html',
    styleUrl: './market-ticker.component.scss',
    standalone: false
})
export class MarketTickerComponent implements OnInit {

  currentRates:any[] = [];

  constructor(private dataManipSrvc:DataManipService, private currentRatesService:CurrentratesService){}
  ngOnInit(): void {
    this.setCurrentRates();
    this.dataManipSrvc.getCurrRates()
      .subscribe(
        data => {
          this.currentRates = [];
          console.log("asynch data : ", data);
          this.currentRates = data;
          this.setCurrentRates();
        }
      )
  }

  setCurrentRates() {
    console.log("setCurrentRates");
    
    if (this.currentRatesService.currentRates != undefined) {
      this.currentRates = this.currentRatesService.currentRates;
      console.log(this.currentRates);
      
    }
    // console.log("currentRates : " + JSON.stringify(this.currentRates));
    if (this.currentRates == null) {
      this.currentRates = [];
    }

    for (let i = 0; i < this.currentRates.length; i++) {
      if (!this.currentRates[i]['goldcarottype']) {
        this.currentRates[i]['goldcarottype'] = 0;
      }
      if (this.currentRates[i]['purchaserate'] == null||undefined||0) {
        this.currentRates[i]['purchaserate'] = 0;
      }
    }
  }
}
